import * as selectors from './selectors'

export const ftMetadataSelectors = selectors
